/* eslint-disable no-unused-vars */

import PropTypes from 'prop-types';
import { useState, useEffect } from 'react';

// material-ui
import { useMediaQuery, Button, ButtonGroup, Grid, Stack, Tooltip, Typography, IconButton, Alert } from '@mui/material';

// third-party
import { format } from 'date-fns';

// assets (Optimized imports)
import LeftOutlined from "@ant-design/icons/LeftOutlined";
import RightOutlined from "@ant-design/icons/RightOutlined";
import AppstoreOutlined from "@ant-design/icons/AppstoreOutlined";
// import LayoutOutlined from "@ant-design/icons/LayoutOutlined";
// import PicCenterOutlined from "@ant-design/icons/PicCenterOutlined";
// import OrderedListOutlined from "@ant-design/icons/OrderedListOutlined";

// constant
const viewOptions = [
  {
    label: 'Month',
    value: 'dayGridMonth',
    icon: AppstoreOutlined
  },
  // {
  //   label: 'Week',
  //   value: 'timeGridWeek',
  //   icon: LayoutOutlined
  // },
  // {
  //   label: 'Day',
  //   value: 'timeGridDay',
  //   icon: PicCenterOutlined
  // },
  // {
  //   label: 'Agenda',
  //   value: 'listWeek',
  //   icon: OrderedListOutlined
  // }
];

// ==============================|| CALENDAR - TOOLBAR ||============================== //

const Toolbar = ({ date, view, onClickNext, selectedCourseInfo, onClickPrev, onClickToday, onChangeView, ...others }) => {
  const matchDownSM = useMediaQuery((theme) => theme.breakpoints.down('sm'));

  const [viewFilter, setViewFilter] = useState(viewOptions);
  

  useEffect(() => {
    if (matchDownSM) {
      const filter = viewOptions.filter((item) => item.value !== 'dayGridMonth' && item.value !== 'timeGridWeek');
      setViewFilter(filter);
    } else {
      setViewFilter(viewOptions);
    }
  }, [matchDownSM]);

  return (
    <Grid alignItems="center" container justifyContent="space-between" spacing={matchDownSM ? 1 : 3} {...others} sx={{ pb: 3 }}>
      <Grid item>
        <Button variant="outlined" onClick={onClickToday} size={matchDownSM ? 'small' : 'medium'}>
          Today
        </Button>
      </Grid>
      <Grid item>
        <Stack direction="row" alignItems="center" spacing={matchDownSM ? 1 : 3}>
          <IconButton onClick={onClickPrev} size={matchDownSM ? 'small' : 'large'}>
            <LeftOutlined />
          </IconButton>
          <Typography variant={matchDownSM ? 'h5' : 'h3'} color="textPrimary">
            {format(date, 'MMMM yyyy')}
          </Typography>
          <IconButton onClick={onClickNext} size={matchDownSM ? 'small' : 'large'}>
            <RightOutlined />
          </IconButton>
        </Stack>
      </Grid>
      <Grid item>
        <ButtonGroup variant="outlined" aria-label="outlined button group">
          {viewFilter.map((viewOption) => {
            const Icon = viewOption.icon;
            return (
              <Tooltip title={viewOption.label} key={viewOption.value}>
                <Button
                  size={matchDownSM ? 'small' : 'medium'}
                  disableElevation
                  variant={viewOption.value === view ? 'contained' : 'outlined'}
                  onClick={() => onChangeView(viewOption.value)}
                >
                  <Icon style={{ fontSize: '1.3rem' }} />
                </Button>
              </Tooltip>
            );
          })}
        </ButtonGroup>
      </Grid>

      {
        selectedCourseInfo?.courseid == 4 && <Stack direction={'row'} justifyContent={'center'} sx={{ width: '100%', marginTop: { xs: '10px', md: '', lg: '' } }}>
          <Alert severity="error">If no slots are available, please navigate to Next Month to view additional classes</Alert>
        </Stack>
      }

    </Grid>
  );
};

Toolbar.propTypes = {
  date: PropTypes.object,
  view: PropTypes.string,
  onClickNext: PropTypes.func,
  onClickPrev: PropTypes.func,
  onClickToday: PropTypes.func,
  onChangeView: PropTypes.func
};

export default Toolbar;
